export default __webpack_public_path__ + "static/media/3DSurfers.34f40fc4.svg";